module.exports = __webpack_public_path__ + "static/media/11.8f6d77ea.png";